module.exports = __webpack_public_path__ + "media/images/login/icon_awesome_arrow_circle_left-50ba14dac92b49356f18523270a3af83.svg";